export enum WriterStatusEnum {
  CREATED_PENDING = 'CREATED_PENDING',
  EDITED_PENDING = 'EDITED_PENDING',
  APPROVED = 'APPROVED',
  CREATED_REJECTED = 'CREATED_REJECTED',
  EDITED_REJECTED = 'EDITED_REJECTED',
}
